import React from 'react';
import { Link } from 'react-router-dom';
import type { PassportEcosystemResult } from '@bilt/types';
export default function PassportResultSummary({ result }: { result?: PassportEcosystemResult }) {
  if (!result || result.schema_version !== 2) return null;
  return (
    <section className="pe-result-summary" aria-label="Recorded outcomes">
      <h2>What this scan recorded</h2>
      <dl>
        <div>
          <dt>Collectible</dt>
          <dd>
            {
              {
                new: 'Added to your Passport',
                owned: 'Already in your Passport',
                none: 'No collectible added',
                pending: 'Waiting for verification',
              }[result.base.outcome]
            }
          </dd>
        </div>
        <div>
          <dt>Visit</dt>
          <dd>
            {
              {
                new: 'New accepted visit',
                same_occasion: 'This occasion was already recorded',
                revoked: 'This visit was corrected or revoked',
                none: 'No visit confirmed',
                pending: 'Visit confirmation pending',
              }[result.visit.outcome]
            }
          </dd>
        </div>
      </dl>
      {result.programs.map((p) => (
        <p key={`${p.program_ref}:${p.cycle}`}>
          <Link to={`/passport/programs/${p.program_ref}`}>
            {p.completion_ref
              ? p.completion_state && p.completion_state !== 'completed' ? 'Program completion under review' : 'Program completed'
              : p.paused_reason ||
                (p.progress
                  ? `Program progress · ${p.progress.progress} of ${p.progress.target}`
                  : 'View program')}
          </Link>
          {p.reward?.entitlement_ref && (
            <>
              {' '}
              · <Link to="/passport/rewards">Benefit · {p.reward.state.replaceAll('_', ' ')}</Link>
            </>
          )}
        </p>
      ))}
    </section>
  );
}
